import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import { ServerErrors } from '../types/errors';

export interface IResponseData extends AxiosResponse {
  success: boolean;
  errors: ServerErrors;
  [x: string]: unknown;
}

interface IErrorResponsePayload {
  response: {
    data: {
      // eslint-disable-next-line camelcase
      redirect_url: string;
    };
    status: number;
  };
}

export const responseErrorHandler = (error: IErrorResponsePayload): Promise<AxiosResponse> => {
  const {
    response: { data, status },
  } = error;

  if (status === 303) {
    const { redirect_url: url } = data;
    window.location.href = url;
  }

  return Promise.reject(error);
};

export const responseSuccessHandler = (response: AxiosResponse<IResponseData>): Promise<AxiosResponse> => {
  const { data } = response;
  const { success, errors } = data;
  if (success) {
    return Promise.resolve(response);
  }
  return Promise.reject(errors);
};

export const configApiService = (baseUrl: string, settings: AxiosRequestConfig = {}): void => {
  const { headers = {}, ...otherSettings } = settings;

  const defaultHeaders = {
    'X-Requested-With': 'XMLHttpRequest',
  };

  axios.defaults.headers.common = {
    ...defaultHeaders,
    ...headers,
  };

  if (otherSettings.withCredentials) {
    axios.defaults.withCredentials = otherSettings.withCredentials;
  }

  axios.defaults.baseURL = baseUrl;

  axios.interceptors.response.use(responseSuccessHandler, responseErrorHandler);
};

export default axios;
